


















import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import AuthUtils from '@/utils/AuthUtils';
import UserUtils from '@/utils/UserUtils';

export default mixins().extend({
  computed: {
    language() {
      return this.$i18n.locale;
    },

    items() {
      return Object.keys(this.$i18n.messages)?.map((locale) => ({
        text: this.$t(`app.label.locale.${locale}`, locale),
        value: locale,
      }));
    },
  },

  methods: {
    async setLocale(locale: string) {
      this.$i18n.locale = locale;
      if (this.$session) {
        AuthUtils.set({ language: locale }); // set locale

        // check for token and role as the user update will fail without both
        if (this.$session.token && this.$session.role) {
          try {
            await UserUtils.api.update({
              id: this.$session.id,
              language: locale,
            });
          } catch (error) {
            console.error('Error updating locale', error);
          }
        }
      }
    },
  },
});
